import { createSlice } from '@reduxjs/toolkit';
import { StakeItem, stakeApi } from '@/store/api/stakesApi';

interface StakeState {
  stakeSet: StakeItem[];
}

const initialState: StakeState = {
  stakeSet: [],
};

export const stakeSlice = createSlice({
  name: 'stake',
  initialState,
  reducers: {
    clearStakeSet: (state) => {
      state.stakeSet = [];
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(stakeApi.endpoints.getStakeSet.matchFulfilled, (state, { payload }) => {
      state.stakeSet = payload?.stakeSet ?? [];
    });
  },
});

export const { clearStakeSet } = stakeSlice.actions;
export default stakeSlice.reducer;
